module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/2/7-79bae0f0019fb0b0307ca2ecfe4fadae.png";